/**
 * Navigation contributed by the ADMIN layer.
 *
 * This file is the layer's ENTIRE contribution to the sidebar. It does not
 * import, wrap or copy AppShell — the shell discovers this file by glob and
 * merges it. See nav.base.ts for why.
 *
 * `role` hides these from non-admins, which is presentation only. The gates
 * that matter are AdminLayoutRoute's role check on /admin and the API's own
 * check on every /admin endpoint.
 */
import { Settings } from 'lucide-react';
import type { NavItem } from './nav.base';

export const items: NavItem[] = [
  // Platform configuration, users, analytics, API keys and the audit log.
  { to: '/admin/settings', label: 'Settings', icon: Settings, role: 'admin', order: 130, platformOnly: true },
  // Same word, a customer's own account: their company, team and domains.
  { to: '/account', label: 'Settings', icon: Settings, role: 'admin', order: 130, tenantOnly: true },
];
